export enum ProductStatusEnum {
  DRAFT = 0,
  PUBLIC = 1,
  PRIVATE = 2,
  SUSPENDED = 3,
  SOLD = 4,
  CANCELED = 5,
  DELETED = 6,
}

export const ProductStatusMap: Record<any, string> = {
  [ProductStatusEnum.DRAFT]: "下書き",
  [ProductStatusEnum.PUBLIC]: "公開中",
  [ProductStatusEnum.PRIVATE]: "非公開",
  [ProductStatusEnum.SUSPENDED]: "凍結中",
  [ProductStatusEnum.SOLD]: "売り切れ",
  [ProductStatusEnum.CANCELED]: "キャンセル",
  [ProductStatusEnum.DELETED]: "削除済",
};

export const getStatusOptions = () => {
  return [
    { value: ProductStatusEnum.DRAFT, label: "下書き" },
    { value: ProductStatusEnum.PUBLIC, label: "公開中" },
    { value: ProductStatusEnum.PRIVATE, label: "非公開" },
    { value: ProductStatusEnum.SUSPENDED, label: "凍結中" },
    { value: ProductStatusEnum.SOLD, label: "売り切れ" },
    { value: ProductStatusEnum.DELETED, label: "削除済" },
    { value: ProductStatusEnum.CANCELED, label: "キャンセル" },
  ];
};

export const PRODUCT_FILTER_STATUS: Record<
  string,
  { value: string; label: string }
> = {
  AVAILABLE: {
    value: ProductStatusEnum.PUBLIC.toString(),
    label: "公開中",
  },
  DRAFT: {
    value: ProductStatusEnum.DRAFT.toString(),
    label: "下書き",
  },
  SUSPENDED: {
    value: ProductStatusEnum.SUSPENDED.toString(),
    label: "凍結中",
  },
  SOLD: {
    value: ProductStatusEnum.SOLD.toString(),
    label: "売り切れ",
  },
  CANCEL: {
    value: ProductStatusEnum.CANCELED.toString(),
    label: "キャンセル",
  },
  DELETE: {
    value: ProductStatusEnum.DELETED.toString(),
    label: "削除済",
  },
  PRIVATE: {
    value: ProductStatusEnum.PRIVATE.toString(),
    label: "非公開",
  },
};
